import { render, staticRenderFns } from "./editKnowledgeFolder.vue?vue&type=template&id=e687147c&lang=pug"
import script from "./editKnowledgeFolder.vue?vue&type=script&lang=js"
export * from "./editKnowledgeFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports